// extracted by mini-css-extract-plugin
module.exports = {"pill":"N2AAK _1Zmlx _2UpWF sHcNu _3wFVT _2XukU _30AcJ _2cc-R","pillWithoutIcon":"_39TcL","pillIconBefore":"_3xGY_","icon":"scFtm"};